const leadsFormMapper = (siteName) => {
    let leadsForm;
    switch (siteName) {
        case 'abritel' :
            leadsForm = 'https://www.abritel.fr/l/agences-immobilieres';
            break;
        case 'homeaway_de' :
            leadsForm = 'https://www.fewo-direkt.de/l/agenturen';
            break;
        case 'homeaway_us' :
            leadsForm = 'https://www.homeaway.com/l/property-managers';
            break;
        case 'homeaway_pt' :
            leadsForm = 'https://www.homeaway.pt/l/gestores-de-imoveis';
            break;
        case 'homeaway_es' :
            leadsForm = 'https://www.homeaway.es/l/profesionales-inmobiliarios';
            break;
        case 'homeaway_uk' :
            leadsForm = 'https://www.homeaway.co.uk/l/property-managers';
            break;
        case 'homeaway_it' :
            leadsForm = 'https://www.homeaway.it/l/professionisti-immobiliari';
            break;
        default:
            leadsForm = 'https://www.homeaway.com/l/property-managers';
            break;
    }

    return leadsForm;
};

export default leadsFormMapper;
